import { render, staticRenderFns } from "./role-add.vue?vue&type=template&id=348662ed&"
import script from "./role-add.vue?vue&type=script&lang=js&"
export * from "./role-add.vue?vue&type=script&lang=js&"
import style0 from "./role-add.vue?vue&type=style&index=0&id=348662ed&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports